import React, { useState, useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import {
  Badge,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  BlockDes,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  TooltipComponent,
  PaginationComponent,
} from "../../../components/Component";
import Swal from "sweetalert2";
import FormatDate from "../DateFormater";
import UomMaster from "./UomMasters";
import { useSelector } from "react-redux";
import { Flex, Spin, Empty } from "antd";
import uomApis from "../../../api/master/uomMaster";

type UomType = {
  id: number;
  referenceID: string;
  uom_type: string;
  uom_name: string;
  uom_short_code: string;
  uom_description: string;
  status: string;
  createdDate: string;
  sNo: number;
};

const UomPage: FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  useEffect(() => {
    if (accessibility) {
      try {
        const { add, view, edit, approve, reject, cancel } =
          accessibility["Master"];
        setAllowedActions({ add, view, edit, approve, reject, cancel });
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);

  const [sm, setSm] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [detail, setDetail]: any = useState({});
  const [popUpContent, setPopUpContent] = useState<JSX.Element | null>(null);
  const [originalData, setOriginalData] = useState<UomType[]>([]);
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [sort, setSortState] = useState("");
  const [rowData, setRowData] = useState<UomType[]>([]);


  const handleModelPopUp = (id?: any, type?: string) => {
    let uomData = null;
    console.log(id, type, originalData);

    if (type === "edit" && id) {
      uomData = originalData.find(item => item.id === id);
    }

    const content = (
      <UomMaster
        formAction={type}
        id={id}
        currentRowData={uomData} // Pass the row data here
        toggleModelPopUp={() => {
          setIsOpen(false);
          fetchData();
        }}
        onSuccess={(newUom, action) => {
          if (action === "create") {
          } else if (action === "edit") {
          }
          setIsOpen(false);
        }}
      />
    );
    setPopUpContent(content);
    setIsOpen(true);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const { data, status, message } = await uomApis.fetchAllUomByOrg();
      if (status) {
        const dataSNo = data.map((item: any, index: number) => ({
          ...item,
          sNo: index + 1,
        }));
        setRowData(dataSNo);
        setOriginalData(dataSNo);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.error("Error fetching UOM data:", error);
      Swal.fire("Error", "Failed to fetch UOM data", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (id: any) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      allowOutsideClick: false,
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-secondary",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("Deleting UOM with ID:", id);
        await deleteUom(id);
      }
    });
  };

  const deleteUom = async (id: any) => {
    try {
      const { status, message } = await uomApis.removeUOM(id);

      if (status) {
        const removeFromData = (prevData: UomType[]) =>
          prevData.filter((item: UomType) => item.id !== id);

        setRowData(removeFromData);
        setOriginalData(removeFromData);

        Swal.fire("Deleted!", message, "success");
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.error("Error deleting UOM:", error);
      Swal.fire("Error", "Failed to delete UOM", "error");
    }
  };

  const viewChange = () => {
    if (window.innerWidth < 990) {
    } else {
      setSm(false);
    }
  };

  const loadDetail = (id: any) => {
    let index = rowData.findIndex((item: any) => item.id === id);
    setDetail(rowData[index]);
  };

  useEffect(() => {
    fetchData();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  useEffect(() => {
    if (onSearchText !== "") {
      const searchText = onSearchText.toLowerCase();

      const filteredObject = originalData.filter((item) => {
        return Object.entries(item).some(([key, value]) => {
          let searchValue = value ? value.toString().toLowerCase() : "";
          return searchValue.includes(searchText);
        });
      });

      setRowData(filteredObject);
    } else {
      setRowData(originalData);
    }
  }, [onSearchText, originalData]);

  const sortFunc = (params: any) => {
    let defaultData = [...rowData];
    if (params === "asc") {
      let sortedData = defaultData.sort((a: any, b: any) =>
        a.uom_name.localeCompare(b.uom_name)
      );
      setRowData(sortedData);
    } else if (params === "dsc") {
      let sortedData = defaultData.sort((a: any, b: any) =>
        b.uom_name.localeCompare(a.uom_name)
      );
      setRowData(sortedData);
    }
  };

  const toggle = () => setonSearch(!onSearch);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = rowData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber: any) => setCurrentPage(pageNumber);

  const onFilterChange = (e: any) => {
    setSearchText(e.target.value);
  };

  return (
    <React.Fragment>
      <Head title="UOM Management"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Units Of Measurement
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>You have {rowData.length} UOMs in total.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""
                    }`}
                  onClick={() => setSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div
                  className="toggle-expand-content"
                  style={{ display: sm ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    {allowedActions?.add ? (
                      <li className="nk-block-tools-opt">
                        <Button
                          color="primary"
                          onClick={() => {
                            handleModelPopUp(null, "");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Add UOM</span>
                        </Button>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <DataTable
            className="card-stretch fixed-width-table"
            bodyClassName={undefined}
            title={undefined}
          >
            <div className="card-inner position-relative card-tools-toggle">
              <div className={`card-search search-wrap active`}>
                <div className="card-body">
                  <div
                    className="search-content"
                    style={{ whiteSpace: "nowrap", display: "flex" }}
                  >
                    <Button className="search-back btn-icon toggle-search active">
                      <Icon name="search"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by UOM Name"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag="a"
                        className="btn btn-trigger btn-icon dropdown-toggle"
                      >
                        <Icon name="filter"></Icon>
                      </DropdownToggle>
                      <DropdownMenu end className="dropdown-menu-xs">
                        <ul className="link-check">
                          <li>
                            <span>Show</span>
                          </li>
                          <li className={itemPerPage === 10 ? "active" : ""}>
                            <DropdownItem
                              tag="a"
                              href="#dropdownitem"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(10);
                              }}
                            >
                              10
                            </DropdownItem>
                          </li>
                          <li className={itemPerPage === 15 ? "active" : ""}>
                            <DropdownItem
                              tag="a"
                              href="#dropdownitem"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(15);
                              }}
                            >
                              15
                            </DropdownItem>
                          </li>
                        </ul>
                        <ul className="link-check">
                          <li>
                            <span>Order</span>
                          </li>
                          <li className={sort === "dsc" ? "active" : ""}>
                            <DropdownItem
                              tag="a"
                              href="#dropdownitem"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setSortState("dsc");
                                sortFunc("dsc");
                              }}
                            >
                              DESC
                            </DropdownItem>
                          </li>
                          <li className={sort === "asc" ? "active" : ""}>
                            <DropdownItem
                              tag="a"
                              href="#dropdownitem"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setSortState("asc");
                                sortFunc("asc");
                              }}
                            >
                              ASC
                            </DropdownItem>
                          </li>
                        </ul>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              </div>
            </div>

            <DataTableBody compact className={undefined} bodyclass={undefined}>
              <DataTableHead className="nk-tb-head">
                <DataTableRow className="nk-tb-col" size="md">
                  <span className="sub-text">UOM ID</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col" size="md">
                  <span className="sub-text">UOM Name</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col" size="md">
                  <span className="sub-text">Short Code</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col" size="md">
                  <span className="sub-text">Description</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col" size="md">
                  <span className="sub-text">Created Date</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col" size="md">
                  <span className="sub-text">Status</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col" size="md">
                  <span className="sub-text"></span>
                </DataTableRow>
              </DataTableHead>
              {currentItems.map((item: any, index: number) => {
                const serialNumber = (currentPage - 1) * itemPerPage + index + 1;
                return (
                  <DataTableItem
                    key={item.id}
                    className="nk-tb-item"
                    style={{ color: "black" }}
                  >
                    <DataTableRow className="nk-tb-col" size="md">
                      <span className="cell-content">{item.uomSequenceId}</span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col" size="md">
                      <span className="cell-content text-wrap" title={item.uom_name}>
                        {item.uom_name}
                      </span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col" size="md">
                      <span className="cell-content text-wrap" title={item.uom_short_code}>
                        {item.uom_short_code}
                      </span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col" size="md">
                      <div>
                        {item.uom_description && item.uom_description.length > 15 ? (
                          <>
                            <span id={`desc-tooltip-${item.id}`}>
                              {`${item.uom_description.substring(0, 15)}... `}
                            </span>
                            <TooltipComponent
                              iconClass="info-circle text-info"
                              icon="info"
                              id={`desc-tooltip-${item.id}`}
                              direction="top"
                              text={item.uom_description}
                              containerClassName={""}
                            />
                          </>
                        ) : (
                          <span>{item.uom_description}</span>
                        )}
                      </div>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col" size="md">
                      <span className="cell-content">
                        {FormatDate(item.createdDate)}
                      </span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col" size="md">
                      <span
                        className={`tb-status text-${item.status === "Active" ? "success" : "danger"}`}
                      >
                        {item.orgID === null ? "Default" : item.status}
                      </span>
                    </DataTableRow>

                    <DataTableRow className="nk-tb-col nk-tb-col-tools" size="md">
                      <ul className="nk-tb-actions">
                        {allowedActions?.edit && item.orgID !== null ? (
                          <li
                            className="nk-tb-action-hidden"
                            onClick={() => handleModelPopUp(item.id, "edit")}
                          >
                            <TooltipComponent
                              tag="a"
                              containerClassName="btn btn-trigger btn-icon"
                              id={"edit" + item.id}
                              icon="edit-alt-fill"
                              direction="top"
                              text="Edit"
                              iconClass={undefined}
                            />
                          </li>
                        ) : (
                          <></>
                        )}
                        <li>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              tag="a"
                              className="dropdown-toggle btn btn-icon btn-trigger"
                            >
                              <Icon name="more-h"></Icon>
                            </DropdownToggle>
                            <DropdownMenu end>
                              <ul className="link-list-opt no-bdr">
                                {allowedActions?.edit && item.orgID !== null ? (
                                  <li onClick={() => { }}>
                                    <DropdownItem
                                      tag="a"
                                      href="#edit"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        handleModelPopUp(item.id, "edit");
                                      }}
                                    >
                                      <Icon name="edit"></Icon>
                                      <span>Edit</span>
                                    </DropdownItem>
                                  </li>
                                ) : null}
                                <li>
                                  <DropdownItem
                                    tag="a"
                                    href="#view"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      loadDetail(item.id);
                                      setViewModal(true);
                                    }}
                                  >
                                    <Icon name="focus"></Icon>
                                    <span>View Details</span>
                                  </DropdownItem>
                                </li>
                                {allowedActions?.edit && item.orgID !== null ? (
                                  <li>
                                    <DropdownItem
                                      tag="a"
                                      href="#delete"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        handleDelete(item.id);
                                      }}
                                    >
                                      <Icon name="trash"></Icon>
                                      <span>Delete</span>
                                    </DropdownItem>
                                  </li>
                                ) : null}
                              </ul>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                );
              })}
            </DataTableBody>
            {isLoading === true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner">
                {currentItems.length > 0 ? (
                  <PaginationComponent
                    itemPerPage={itemPerPage}
                    totalItems={rowData.length}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                      backgroundColor: "white",
                    }}
                  >
                    <Empty description="No Data Found " />
                  </div>
                )}
              </div>
            )}
          </DataTable>
        </Block>
      </Content>
      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        className="modal-dialog-centered"
        size="lg"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsOpen(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>{popUpContent}</ModalBody>
      </Modal>
      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        className="modal-dialog-centered"
        size="lg"
        backdrop="static"
      >
        <ModalBody>
          <a
            href="#cancel"
            onClick={(ev) => {
              ev.preventDefault();
              setViewModal(false);
            }}
            className="close"
          >
            <Icon name="cross-sm"></Icon>
          </a>
          <div className="nk-modal-head">
            <h4 className="nk-modal-title title">
              UOM Details -{" "}
              <small className="text-primary">
                {" "}
                {detail?.uom_name}
              </small>
            </h4>
          </div>
          <div className="nk-tnx-details mt-sm-3">
            <Row className="gy-3">
              <Col lg={6}>
                <span className="sub-text">UOM ID</span>
                <span className="caption-text">{detail?.uomSequenceId}</span>
              </Col>
              <Col lg={6}>
                <span className="sub-text">UOM Name</span>
                <span className="caption-text">{detail?.uom_name}</span>
              </Col>
              <Col lg={6}>
                <span className="sub-text">Short Code</span>
                <span className="caption-text">{detail?.uom_short_code}</span>
              </Col>

              <Col lg={6}>
                <span className="sub-text">Description</span>
                <span className="caption-text">{detail?.uom_description}</span>
              </Col>
              <Col lg={6}>
                <span className="sub-text">Status</span>
                <Badge
                  color={detail?.status === "Active" ? "success" : "danger"}
                  size="md"
                >
                  {detail?.status}
                </Badge>
              </Col>
              <Col lg={6}>
                <span className="sub-text">Created Date</span>
                <span className="caption-text">
                  {FormatDate(detail?.createdDate)}
                </span>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default UomPage;